<template>
    <tenancies-terminate-update
        :uuid="tenancy.uuid"
        @success="show_edit_modal = false; show_updated_modal = true"
    >
        <div
            slot-scope="{
                is_loading: is_saving,
                error,
                update,
                forget
            }"
        >
            <error-modal
                v-if="error"
                :error="error"
                @close="forget"
            />

            <modal-success
                v-else-if="show_updated_modal"
                :is-open="show_updated_modal"
                @close="closeAll(); $emit('success')"
            >
                <template slot="heading">Tenancy Terminated!</template>

                <p>Tenancy successfully terminated.</p>

                <div
                    slot="footer"
                    slot-scope="{ close }"
                    class="flex flex-col md:flex-row-reverse"
                >
                    <button
                        type="button"
                        @click.prevent="close"
                        class="text-center btn"
                    >
                        Close
                    </button>
                </div>
            </modal-success>

            <modal-red
                v-else-if="show_edit_modal"
                :is-open="show_edit_modal"
                @close="closeAll"
            >
                <base-form
                    slot-scope="{ close }"
                    @submit="update"
                >
                    <div class="px-4 pt-4 pb-3 sm:p-6">
                        <h6 class="mb-3 text-lg font-normal font-semibold text-center">
                            Terminate tenancy
                        </h6>

                        <div class="text-grey-darker">
                            <p class="mb-3">End the tenancy now. Writing off any outstanding balance.</p>

                            <p><strong>Warning: </strong>You cannot undo this action!</p>
                        </div>
                    </div>

                    <footer class="flex flex-col px-6 py-3 rounded-b md:flex-row-reverse bg-grey-bg">
                        <base-button
                            :is-loading="is_saving"
                            type="submit"
                            class="w-full btn btn-red md:w-auto"
                        >
                            Terminate Tenancy
                        </base-button>

                        <button
                            type="button"
                            class="text-center btn md:mr-3"
                            @click.prevent="close"
                        >
                            Cancel
                        </button>
                    </footer>
                </base-form>
            </modal-red>
        </div>
    </tenancies-terminate-update>
</template>

<script>
    import TenanciesTerminateUpdate from '../../../../../../components/tenancies-terminate-update'

    export default {
        components: {
            TenanciesTerminateUpdate
        },
        model: {
            prop: 'toggled',
            event: 'toggle'
        },
        props: {
            toggled: {
                type: Boolean,
                required: true
            },
            tenancy: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_edit_modal: this.toggled,
                show_updated_modal: false
            }
        },
        watch: {
            toggled () {
                this.show_edit_modal = this.toggled
            }
        },
        methods: {
            closeAll () {
                this.show_updated_modal = false
                this.show_edit_modal = false

                this.$emit('toggle', false)
            },
            onSuccess () {
                this.show_edit_modal = false
                this.show_updated_modal = true
            }
        }
    }
</script>
